import React, { useState, useEffect } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import { Grid, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography } from '@mui/material';
import { CSVLink } from 'react-csv';
import { getCvs } from '../cv/services';

const InsightsDashboard = () => {
  const [cvs, setCvs] = useState(null);
  const [occupationCount, setOccupationCount] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const handleSearch = async () => {
    try {
      const cvResponse = await getCvs();
      if (cvResponse.status === 200) {
        const data = cvResponse.data;
        const count = getOccupationCount(data);
        setOccupationCount(count);
        setCvs(data);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error in search:', error.message);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const getOccupationCount = (cvs) => {
    const occupations = cvs
      .map((cv) => cv?.extraField?.occupation)
      .filter((occupation) => typeof occupation === 'string'); // Filter out non-string entries
  
    const flattenedOccupations = occupations
      .flatMap((occupation) => {
        // Split the designations based on commas
        const splitDesignations = occupation.split(',').map((designation) => designation.trim());
        return splitDesignations;
      })
      .map((designation) => designation.toLowerCase()) // Convert to lowercase
      .sort();
  
    const count = flattenedOccupations.reduce((acc, lowercaseOccupation) => {
      const originalCaseOccupation = occupations.find(
        (occupation) => typeof occupation === 'string' && occupation.toLowerCase().includes(lowercaseOccupation)
      );
  
      acc[originalCaseOccupation] = (acc[originalCaseOccupation] || 0) + 1;
      return acc;
    }, {});
  
    console.log(count);
    return count;
  };
  
  
  
  
  
  

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center', paddingTop: 10, paddingBottom: 10 }}>
              <div>
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                  Total Candidates: {cvs ? cvs.length : 0}
                </Typography>

                {isLoading ? (
                  <p>Loading...</p>
                ) : Object.keys(occupationCount).length > 0 ? (
                  <>
                    <Button variant="contained" color="primary">
                      <CSVLink data={Object.entries(occupationCount)} headers={['occupation', 'count']} filename="occupation_count.csv">
                        Export Data
                      </CSVLink>
                    </Button>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Occupation</TableCell>
                            <TableCell align="right">Count</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.entries(occupationCount).map(([occupation, count]) => (
                            <TableRow key={occupation}>
                              <TableCell component="th" scope="row">
                                {occupation}
                              </TableCell>
                              <TableCell align="right">{count}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <p>No data available for Occupations</p>
                )}
              </div>
            </div>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default InsightsDashboard;
